module.exports = __webpack_public_path__ + "static/media/addOn.b3831e84.svg";